<template>
  <EncodingList />
</template>

<script>
import EncodingList from '@/components/encoding/EncodingList.vue';

export default {
  components: {
    EncodingList
  },
}
</script>

<style lang="scss" scoped></style>